import api from "@/api";
import { setLocalStorage } from "@/utilities/common";

// do NOT change these data unless you own all reated background things.
type TemplateDataItem = { name?: string, description?: string, imgUrl: string, link?: string }
export type TemplateDataItemProps = {
  channel: string,
  description?: string,
  id: number,
  layoutImage?: string,
  metaData?: string,
  name: string
}
// let TemplateData: { [id: number]: TemplateDataItem } = {
//   101: { name: "PC通顶基础样式", imgUrl: "" },
//   102: { name: "PC通顶高级样式", imgUrl: "" },
//   103: { name: "PC基础样式", imgUrl: "" },
//   104: { name: "PC高级样式", imgUrl: "" },
//   105: { name: "PC通顶高级样式（GIF）", imgUrl: "" },
//   106: { name: "Mobile通顶样式（测试）", imgUrl: "" },
//   1001: {
//     name: "PC通顶-图文",
//     description: "V1",
//     imgUrl: "",
//     link: ""
//   },
//   1002: {
//     name: "PC通顶-商品栏",
//     description: "V2",
//     imgUrl: "",
//     link: ""
//   },
//   1003: {
//     name: "PC通顶-通图",
//     description: "V3",
//     imgUrl: "",
//     link: ""
//   },
//   1004: {
//     name: "PC基础样式&右侧图片",
//     description: "T1S1",
//     imgUrl: "",
//     link: ""
//   },
//   1007: {
//     name: "PC基础样式&右侧图文",
//     description: "T1S4",
//     imgUrl: "",
//     link: ""
//   },
//   1008: {
//     name: "PC基础样式-表格&右侧图片",
//     description: "T2S1",
//     imgUrl: "",
//     link: ""
//   },
//   10011: {
//     name: "PC基础样式-表格&右侧图文",
//     description: "T2S4",
//     imgUrl: "",
//     link: ""
//   },
//   10012: {
//     name: "PC高级样式-多链接&右侧图片",
//     description: "T3S1",
//     imgUrl: "",
//     link: ""
//   },
//   10015: {
//     name: "PC高级样式-多链接&右侧图文",
//     description: "T3S4",
//     imgUrl: "",
//     link: ""
//   },
//   10016: {
//     name: "PC高级样式&右侧图片",
//     description: "T4S1",
//     imgUrl: "",
//     link: ""
//   },
//   10019: {
//     name: "PC高级样式&右侧图文",
//     description: "T4S4",
//     imgUrl: "",
//     link: ""
//   },
//   10020: {
//     name: "PC高级样式-多图及多链接&右侧图片",
//     description: "T5S1",
//     imgUrl: "",
//     link: ""
//   },
//   10023: {
//     name: "PC高级样式-多图及多链接&右侧图文",
//     description: "T5S4",
//     imgUrl: "",
//     link: ""
//   },
//   10024: {
//     name: "PC高级样式-多图&右侧图片",
//     description: "T6S1",
//     imgUrl: "",
//     link: ""
//   },
//   10027: {
//     name: "PC高级样式-多图&右侧图文",
//     description: "T6S4",
//     imgUrl: "",
//     link: ""
//   },
//   1009: {
//     name: "PC通顶-简约商品栏",
//     description: "V6",
//     imgUrl: "",
//     link: ""
//   },
//   1010: {
//     name: "PC通顶-简约商品栏（GIF）",
//     description: "V7",
//     imgUrl: "",
//     link: ""
//   },
//   1011: {
//     name: "PC通顶-商品栏(GIF)(非通顶)",
//     description: "V8",
//     imgUrl: "",
//     link: ""
//   },
//   1012: {
//     name: "PC通顶-商品栏(GIF)(通顶)",
//     description: "V9",
//     imgUrl: "",
//     link: ""
//   },
//   1013: {
//     name: "PC通顶-简约商品栏(GIF)",
//     description: "V10",
//     imgUrl: "",
//     link: ""
//   },
//   // Mobile
//   11001: {
//     name: "Mobile通顶-图片&按钮",
//     imgUrl: "",
//     link: ""
//   },
//   11002: {
//     name: "Mobile通顶-图片&图片按钮 ",
//     imgUrl: "",
//     link: ""
//   },
//   11003: {
//     name: "Mobile通顶-图片&下载按钮 ",
//     imgUrl: "",
//     link: ""
//   }
// };
export const getAllChildren = (items: any): any[] => {
  return items.reduce((acc:any, item:any) => {
    const { children = [], ...rest } = item;
    return [...acc, rest, ...getAllChildren(children)];
  }, []);
};
export default async function getTemplate () {
  const result:any = await api.AdCreativeForm.Getgrouptemplate({ targetMarket: "" });
  const temp: { [key: number]: TemplateDataItemProps } = {};
  getAllChildren(result || []).forEach((item: TemplateDataItemProps) => {
    temp[item.id] = item;
  });
  setLocalStorage("templateData", Object.assign(temp, { 1010: { channel: "pc", name: "PC通顶-简约商品栏（GIF）", id: 1010 } }));
}
